<template>
  <div class="relative isolate flex items-center gap-x-6 overflow-hidden bg-red-600 px-6 py-2.5 sm:px-3.5 sm:before:flex-1">
    <div class="flex flex-wrap items-center gap-x-4 gap-y-2">
      <p class="text-sm/6 text-white">
        <strong class="font-semibold">Méně administrativy, více času pro pacienty.</strong><svg viewBox="0 0 2 2" class="mx-2 inline size-0.5 fill-current" aria-hidden="true"><circle cx="1" cy="1" r="1" /></svg>Představujeme EZLab – aplikaci, která Vám usnadní život.
      </p>
      <router-link
        :to="{ name: 'ezlab' }"
        class="flex-none rounded-full bg-gray-900 px-3.5 py-1 text-sm font-semibold text-white shadow-sm hover:bg-gray-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-900"
      >
        Prozkoumat výhody <span aria-hidden="true">&rarr;</span>
      </router-link>
    </div>
    <div class="flex flex-1 justify-end">
    </div>
  </div>
</template>
<script setup lang="ts">
</script>
